import  { useEffect, useState } from 'react'
import { Box, Typography } from "@mui/material";
import { ApiService } from '../../API/AxiosInstance';
import moment from 'moment';
import { ShimmerSkeleton } from '../../utils/SkimmerSkeleton';
import { colors } from '../../Theme/tokens';

export default function UserPersonalInfo() {  
  const [userDatas, setUserData] = useState([])
  const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ''
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if(userId) {
      getUserInfo()
    }
  },[userId])

  const getUserInfo = async() => {
    setLoading(true)
    try {
      const response =  await ApiService().get(`users/${userId}`)
      console.log("ggdgdgdg")
     if(response?.data?.user) {
      console.log("resposnez ",response)
       setUserData(response.data.user)
       setLoading(false)
     }

   } catch(error) {
     setLoading(false)
   }
  }

  return (
    <Box mt={2} sx={{  borderRadius: '18px', padding: '20px', display: 'flex', gap: '5px', backgroundColor: colors.background.paper, flexDirection: 'column',boxShadow: `0px 1px 5px 0px ${colors.border.card}` }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', justifyContent: 'center' }}>
          <Typography variant='h3' sx={{color:  colors.text.primary, fontWeight:"600", letterSpacing:"0.5%"}} >Personal Information</Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ my: 1.5 }} >
            <Typography variant='h5_2' sx={{ color: 'Grey', lineHeight: '37px' }}>First Name</Typography>
            {!loading ? <Typography variant='h4' >{userDatas?.firstName}</Typography> : <ShimmerSkeleton  sx={{width:"150px", height:"20px", mb:2}} />}
          </Box>
          <Box sx={{ my: 1.5 }}>
            <Typography variant='h5_2' sx={{ color: 'Grey', lineHeight: '37px' }}>Email Address</Typography>
            {!loading ? <Typography variant='h4' >{userDatas?.email}</Typography> : <ShimmerSkeleton  sx={{width:"150px", height:"20px", mb:2}} />}
          </Box>
          <Box sx={{ my: 1.5 }}>
            <Typography variant='h5_2' sx={{ color: 'Grey', lineHeight: '37px' }}>Date of Birth</Typography>
            {!loading ? <Typography variant='h4' >{userDatas?.dateOfBirth ? moment(userDatas?.dateOfBirth).format('Do MMMM, YYYY') : '-'}</Typography> : <ShimmerSkeleton  sx={{width:"150px", height:"20px", mb:2}} />}
          </Box>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ my: 1.5 }}>
            <Typography variant='h5_2' sx={{ color: 'Grey', lineHeight: '37px' }}>Last Name</Typography>
            {!loading ? <Typography variant='h4' >{userDatas?.lastName}</Typography> : <ShimmerSkeleton  sx={{width:"150px", height:"20px", mb:2}} />}
          </Box>
          <Box sx={{ my: 1.5 }}>
            <Typography variant='h5_2' sx={{ color: 'Grey', lineHeight: '37px' }}>Phone</Typography>
            {!loading ? <Typography variant='h4' >{userDatas?.mobileNo}</Typography> : <ShimmerSkeleton  sx={{width:"150px", height:"20px", mb:2}} />}
          </Box>
        </Box>
        <Box>

        </Box>
      </Box>


    </Box>
  )
}